/* tslint:disable */

declare var Object: any;
export interface PromoCodeInterface {
  "name": string;
  "description"?: string;
  "code": string;
  "displayName"?: string;
  "startAt": Date;
  "endAt": Date;
  "active": boolean;
  "pattern"?: string;
  "type"?: string;
  "createdAt": Date;
  "createdBy"?: number;
  "updatedAt": Date;
  "updatedBy"?: number;
  "id"?: number;
}

export class PromoCode implements PromoCodeInterface {
  "name": string;
  "description": string;
  "code": string;
  "displayName": string;
  "startAt": Date;
  "endAt": Date;
  "active": boolean;
  "pattern": string;
  "type": string;
  "createdAt": Date;
  "createdBy": number;
  "updatedAt": Date;
  "updatedBy": number;
  "id": number;
  constructor(data?: PromoCodeInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PromoCode`.
   */
  public static getModelName() {
    return "PromoCode";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PromoCode for dynamic purposes.
  **/
  public static factory(data: PromoCodeInterface): PromoCode{
    return new PromoCode(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PromoCode',
      plural: 'PromoCodes',
      path: 'PromoCodes',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "code": {
          name: 'code',
          type: 'string'
        },
        "displayName": {
          name: 'displayName',
          type: 'string'
        },
        "startAt": {
          name: 'startAt',
          type: 'Date'
        },
        "endAt": {
          name: 'endAt',
          type: 'Date'
        },
        "active": {
          name: 'active',
          type: 'boolean'
        },
        "pattern": {
          name: 'pattern',
          type: 'string'
        },
        "type": {
          name: 'type',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'number'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "updatedBy": {
          name: 'updatedBy',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
